import { useMemo } from "react";
import "./App.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Routing from "./routes";
import { BrowserRouter } from "react-router-dom";

// Validate required environment variables
const validateEnvironment = () => {
  const requiredVars = {
    VITE_RECAPTCHA_SITE_KEY: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
  };

  const missingVars = Object.entries(requiredVars)
    .filter(([, value]) => !value)
    .map(([key]) => key);

  if (missingVars.length > 0) {
    console.warn(`Missing environment variables: ${missingVars.join(", ")}`);
  }
};

const App = () => {
  // Validate environment on app startup
  validateEnvironment();

  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            // staleTime: 5 * 60 * 1000, // 5 minutes
            retry: (failureCount, error: unknown) => {
              // Don't retry on 4xx errors except 401 (handled by auth)
              const err = error as { status?: number } | undefined;
              if (
                err?.status !== undefined &&
                err.status >= 400 &&
                err.status < 500 &&
                err.status !== 401
              ) {
                return false;
              }
              return failureCount < 3;
            },
            refetchOnWindowFocus: false,
          },
          mutations: {
            retry: false,
          },
        },
      }),
    [],
  );

  return (
    <BrowserRouter basename={import.meta.env.VITE_APP_BASE_URL ?? ""}>
      <QueryClientProvider client={queryClient}>
        <Routing />
      </QueryClientProvider>
    </BrowserRouter>
  );
};

export default App;
